import { useTranslation } from 'react-i18next';
import { format } from 'utils/format';

export default function DrawerOffer({
  amount,
  dueDate,
}: {
  amount?: number;
  mtp?: number;
  dueDate?: string;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col text-[14px]" data-test="drawer-offer-layout">
      <div className="flex justify-between py-3 border-t border-b items-baseline">
        <div data-test="drawer-offer-due-date-text">
          {t('calculator:offer.due_date')}
        </div>
        {amount ? (
          <div data-test="drawer-offer-due-date">
            {format.dateTime(dueDate, 'date')}
          </div>
        ) : (
          <div
            className="animate-pulse bg-background-accent h-6 w-24"
            data-test="drawer-offer-loading"
          />
        )}
      </div>

      <div className="flex justify-between py-3 border-t border-b items-baseline font-bold">
        <div data-test="drawer-offer-total-repayable-amount-text">
          {t('calculator:offer.totalRepayableAmount')}
        </div>
        {dueDate ? (
          <div data-test="drawer-offer-amount">
            {format.number(amount, 'currency')}
          </div>
        ) : (
          <div className="animate-pulse bg-background-accent h-6 w-24" />
        )}
      </div>
    </div>
  );
}
